var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPrice(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "7 7 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29 13H15v17h10l4-4V13z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25 30v-4h4M19 15h6M19 17h6M20.252 19.5v7.503M20.5 19.5H22c.628 0 2 0 2 2s-1.372 2-2 2h-2.5M19.5 25.5H22"
  })));
}

export default SvgPrice;